import { render, staticRenderFns } from "./close-case-step.vue?vue&type=template&id=336fc25a"
import script from "./close-case-step.vue?vue&type=script&lang=ts"
export * from "./close-case-step.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports